const itemGroupToSectorMapping = {
  AUDIO_HOME_SYS: 'Consumer Electronics',
  DENTAL_CARE: 'SDA',
  AIRCONDITIONING: 'MDA',
  AMPLIFIER: 'Consumer Electronics',
  AV_MOUNTING_SOLUTIONS_AND_FURN: 'Consumer Electronics',
  BUILTINHOBS: 'MDA',
  CAR_AUDIO: 'Consumer Electronics',
  CAR_SPEAKERS: 'Consumer Electronics',
  CAR_VISION: 'Consumer Electronics',
  COMMUNICATION_CARDS: 'IT-Office',
  COMMUNICATION_DEVICES: 'IT-Office',
  COOLING: 'MDA',
  CORE_WEARABLES: 'Mobile Phone',
  CAMCORDER: 'Consumer Electronics',
  CAR_NAVIGATION: 'Consumer Electronics',
  COOKING: 'MDA',
  DESKBOUND_COMPUTERS: 'IT-Office',
  DISHWASHERS: 'MDA',
  ELECTRICAL_COOKING_POTS: 'SDA',
  FINANCIAL_SOFTWARE: 'IT-Office',
  FOODPREPARATION: 'SDA',
  FREEZERS: 'MDA',
  FUN_COOKING: 'SDA',
  GAMING_AND_LEISURE_DEVICES: 'IT-Office',
  HOODS: 'MDA',
  HOT_BEVER_MAKER: 'SDA',
  KETTLES: 'SDA',
  KEYING_DEV: 'IT-Office',
  LOUDSPEAKERS: 'Consumer Electronics',
  MALESHAVERS: 'SDA',
  MEDIATABLETS: 'IT-Office',
  MICROWAVE_OVENS: 'MDA',
  MOBILE_COMPUTING: 'IT-Office',
  MONITORS: 'IT-Office',
  POINTING_DEV: 'IT-Office',
  PORTABLE_MEDIA_PLAYER: 'Consumer Electronics',
  PRINTING: 'IT-Office',
  PTV_FLAT: 'Consumer Electronics',
  'RADIO_DEVICES_(TABLE_TOP)': 'Consumer Electronics',
  RECEIVER: 'Consumer Electronics',
  SET_TOP_BOXES: 'Consumer Electronics',
  SMPPHAB_WITH_REFURB: 'Mobile Phone',
  STEAM_OVENS: 'MDA',
  STORAGE: 'IT-Office',
  TUMBLE_DRYERS: 'MDA',
  TUNER: 'Consumer Electronics',
  TURNTABLE: 'Consumer Electronics',
  UNIVERSAL_REMOTECONTROLS: 'Consumer Electronics',
  VIDEO_PLAYER_AND_RECORDERS: 'Consumer Electronics',
  VISUAL_CAMS: 'IT-Office',
  WASHINGMACHINES: 'MDA',
  WINE_CABINETS: 'MDA',
  HEADSETS_TOTAL: 'Mobile Phone',
  MOBILEPHONES: 'Mobile Phone',
  DIGITAL_ASSISTANTS: 'IT-Office',
  VIDEO_GAMES_HARDWARE: 'Consumer Electronics',
  DRINK_CHILLERS: 'MDA',
  ES_AND_PT_VGS: 'Consumer Electronics',
  DIGITAL_TV_ACCESSORIES: 'Consumer Electronics',
  GAMING_EXCL_PREPAYCARDS: 'IT-Office',
  MULTIDISC_DRIVE: 'IT-Office',
  GAMES_SOFTWARE: 'Consumer Electronics',
  LEISURE_GPS: 'Consumer Electronics',
  MICROPHONES: 'Consumer Electronics',
  CD_PLAYER: 'Consumer Electronics',
  ERGONOMIC_ACCESSORIES: 'IT-Office',
  HOUSINGS: 'IT-Office',
  MAINBOARDS: 'IT-Office',
  'MM-DEVICES': 'IT-Office',
  SECURITY_DEVICES: 'IT-Office',
  SHAVER_ACCESSORIES: 'SDA',
  FREESTANDING_HOBS: 'MDA',
  LAUNDRY_APPLIANCES_BASE: 'MDA',
  SOUNDBAR_BASE: 'Consumer Electronics',
  MEMORY_MODULES: 'IT-Office',
  DESKBOUND_COMPUTERS_JP: 'IT-Office',
  AUDIO_HOME_SYS_WITHOUT_SMART_AUDIO: 'Consumer Electronics',
  DESKBOUND_COMPUTERS_EXCL_MEDIAGW: 'IT-Office',
  MEDIA_GATEWAYS: 'IT-Office',
  CAR_NAVIGATION_PORTABLE: 'Consumer Electronics',
  GAMING_PREPAYCARDS: 'IT-Office',
  MEDIABOX_AND_MEDIASTICK: 'IT-Office',
  MEDIABOX_AND_MEDIASTICK_AND_MEDIATABLETS: 'IT-Office',
  TUNER_AND_AMPLIFIER_AND_RECEIVER: 'Consumer Electronics',
};

const getRetailerSectorByItemGroupCode = (itemGroupCode: string): string | undefined =>
  itemGroupToSectorMapping[itemGroupCode];

export default getRetailerSectorByItemGroupCode;
